module.exports = __webpack_public_path__ + "media/images/review/ico-review-upload-a70ecced2163e69d0d26ed9808d4a67a.svg";